<template>
  <div class="progress-bar">
    <div class="progress" :style="`width: ${progress}%; background: ${$store.state.settings.progressBar.color.hex}`"/>
  </div>
</template>

<script>
export default {
  computed: {
    progress () {
      return this.$store.state.step * 100 / this.$store.state.questions.length
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 10px;
  width: 100%;

  .progress {
    position: absolute;
    height: 100%;
    background: #1abc9c;
    transition: .3s;
  }
}
</style>
